<template>
  <div :class="'hb_entity_editor_container hb_entity_editor_container_' + id">
    <slot name="title">
      <div :class="'hb_entity_editor_title hb_entity_editor_title' + id">
        {{ title }}
      </div>
    </slot>
    <slot name="editor">
      <b-table-simple responsive :striped="striped" :bordered="bordered" :borderless="borderless" :outlined="outlined"
        :small="small" :hover="hover" :fixed="fixed" :no-border-collapse="noCollapse">
        <b-tbody>
          <b-tr v-for="setting in settings" :key="setting.seq">
            <template v-for="col in setting.cols">
              <b-td v-if="col.is_editor" :key="col.seq" class="hb_entity_editor_editor_td"
                :colspan="get_colspan(col.setting.editor.layout)">
                <div :class="get_class(col.setting.editor.layout)" :style="get_style(col.setting.editor.layout)">
                  <template v-if="get_prefix_type(col.setting.editor.layout) === 'text'">
                    <span>{{ get_prefix(col.setting.editor.layout) }}</span>
                  </template>
                  <template v-if="
                    get_prefix_type(col.setting.editor.layout) === 'button'
                  ">
                    <b-button variant="link" :class="get_prefix(col.setting.editor.layout).class
                      ? get_prefix(col.setting.editor.layout).class
                      : ''
                      " size="sm" @click="
                        on_button_click(
                          get_prefix(col.setting.editor.layout).name,
                          item
                        )
                        ">
                      <span v-if="get_prefix(col.setting.editor.layout).icon_class"><i :class="get_prefix(col.setting.editor.layout).icon_class
                        "></i></span>
                      {{ get_prefix(col.setting.editor.layout).label }}
                    </b-button>
                  </template>

                  <template v-for="(f, index) in col.setting.value_fields">
                    <template v-if="col.setting.readonly">
                      <div :key="f" v-if="col.setting.type === 'boolean'" style="width: 100%;">
                        <i v-if="item[f]" class="fa fa-check"></i>
                        <span v-else></span>
                      </div>
                      <!-- <span v-else-if="col.setting.type === 'integer'" :key="f">
                        {{ display_number_value(item[f]) }}
                      </span>
                      <span v-else-if="col.setting.type === 'number'" :key="f">
                        {{ display_number_value(item[f], col.setting.precise) }}
                      </span> -->
                      <span v-else-if="col.setting.options !== undefined" :key="f">{{
                        display_options_value(
                          item[f],
                          col.setting.options.provider(
                            col.setting.options.base_on_field
                              ? item[col.setting.options.base_on_field]
                              : null
                          )
                        )
                      }}</span>
                      <el-link :key="f" v-else-if="col.setting.route_link_to"
                        @click="goto(col.setting.route_link_to, item[f])" type="primary">
                        <span class="hb_route_link_to_text">{{
                          display_value(col.setting.type, item[f], col.setting.precise) }}</span>
                      </el-link>
                      <span v-else :key="f">
                        {{ display_value(col.setting.type, item[f], col.setting.precise) }}
                      </span>
                      <template v-if="index < col.setting.value_fields.length - 1">
                        <span :key="f">{{
                          get_delimiter(col.setting.editor.layout)
                          }}</span>
                      </template>
                    </template>
                    <template v-else>
                      <el-select :key="f" v-if="col.setting.options !== undefined" v-model="item[f]" placeholder=""
                        filterable @change="on_change(f, item)" @focus="on_focus(f, item)">
                        <el-option v-for="option in col.setting.options.provider(
                          col.setting.options.base_on_field
                            ? item[col.setting.options.base_on_field]
                            : null
                        )" :key="option.value" :label="option.label" :value="option.value">
                        </el-option>
                      </el-select>
                      <el-input :key="f" v-else-if="col.setting.type === 'integer'" v-model="item[f]"
                        :maxlength="get_maxlength(col.setting.editor.layout)"
                        :minlength="get_minlength(col.setting.editor.layout)" @keydown.native="only_integer"
                        @change="on_change(f, item)" @focus="on_focus(f, item)"
                        @input="on_input(f, col.setting.type, item)" @blur="on_blur(f, col.setting.type, item)" :class="'hb_table_column_number hb_table_column_number_' + f
                          "></el-input>
                      <el-input :key="f" v-else-if="col.setting.type === 'number'" v-model="item[f]"
                        :maxlength="get_maxlength(col.setting.editor.layout)"
                        :minlength="get_minlength(col.setting.editor.layout)" @keydown.native="only_number"
                        @change="on_change(f, item)" @focus="on_focus(f, item)"
                        @input="on_input(f, col.setting.type, item)" @blur="on_blur(f, col.setting.type, item)" :class="'hb_table_column_number hb_table_column_number_' + f
                          "></el-input>
                      <el-date-picker :key="f" v-else-if="col.setting.type === 'date'" v-model="item[f]"
                        @change="on_change(f, item)" @focus="on_focus(f, item)" :class="'hb_table_column_date hb_table_column_date_' + f
                          "></el-date-picker>
                      <el-date-picker :key="f" v-else-if="col.setting.type === 'datetime'" type="datetime"
                        v-model="item[f]" @change="on_change(f, item)" @focus="on_focus(f, item)" :class="'hb_table_column_datetime hb_table_column_datetime_' +
                          f
                          "></el-date-picker>
                      <el-checkbox :key="f" v-else-if="col.setting.type === 'boolean'" v-model="item[f]"
                        @change="on_change(f, item)" @focus="on_focus(f, item)" :class="'hb_table_column_boolean hb_table_column_boolean_' + f
                          "></el-checkbox>
                      <el-input :key="f" type="textarea" :maxlength="get_maxlength(col.setting.editor.layout)"
                        :minlength="get_minlength(col.setting.editor.layout)"
                        :resize="get_resize(col.setting.editor.layout)"
                        :autosize="get_autosize(col.setting.editor.layout)" :rows="get_rows(col.setting.editor.layout)"
                        lang="xxx" spellcheck="false" :class="'hb_table_column_textarea hb_table_column_textarea_' +
                          f
                          " v-else-if="get_textarea(col.setting.editor.layout)" v-model="item[f]"></el-input>
                      <el-input :key="f" type="text" :maxlength="get_maxlength(col.setting.editor.layout)"
                        :minlength="get_minlength(col.setting.editor.layout)" lang="xxx" spellcheck="false" :class="'hb_table_column_textarea hb_table_column_textarea_' +
                          f
                          " v-else v-model="item[f]"></el-input>
                      <template v-if="index < col.setting.value_fields.length - 1">
                        <span :key="f">{{
                          get_delimiter(col.setting.editor.layout)
                          }}</span>
                      </template>
                    </template>
                  </template>

                  <template v-if="get_suffix_type(col.setting.editor.layout) === 'text'">
                    <span>{{ get_suffix(col.setting.editor.layout) }}</span>
                  </template>
                  <template v-if="
                    get_suffix_type(col.setting.editor.layout) === 'button'
                  ">
                    <b-button variant="link" :class="get_suffix(col.setting.editor.layout).class
                      ? get_suffix(col.setting.editor.layout).class
                      : ''
                      " size="sm" @click="
                        on_button_click(
                          get_suffix(col.setting.editor.layout).name,
                          item
                        )
                        ">
                      <span v-if="get_suffix(col.setting.editor.layout).icon_class"><i :class="get_suffix(col.setting.editor.layout).icon_class
                        "></i></span>
                      {{ get_suffix(col.setting.editor.layout).label }}
                    </b-button>
                  </template>
                </div>
              </b-td>
              <b-td v-else-if="col.setting.type === 'divider'" :key="col.seq" class="hb_entity_editor_label_td"
                :colspan="get_colspan(col.setting.label.layout)">
                <el-divider></el-divider>
              </b-td>
              <b-td v-else-if="col.setting.type === ''" :key="col.seq" class="hb_entity_editor_label_td"
                :colspan="get_colspan(col.setting.label.layout)">
              </b-td>
              <b-td v-else :key="col.seq" class="hb_entity_editor_label_td"
                :colspan="get_colspan(col.setting.label.layout)">
                <div :class="get_class(col.setting.label.layout)" :style="get_style(col.setting.label.layout)">
                  <template v-if="get_prefix_type(col.setting.label.layout) === 'text'">
                    <span>{{ get_prefix(col.setting.label.layout) }}</span>
                  </template>
                  <template v-if="
                    get_prefix_type(col.setting.label.layout) === 'button'
                  ">
                    <b-button variant="link" :class="get_prefix(col.setting.label.layout).class
                      ? get_prefix(col.setting.label.layout).class
                      : ''
                      " size="sm" @click="
                        on_button_click(
                          get_prefix(col.setting.label.layout).name,
                          item
                        )
                        ">
                      <span v-if="get_prefix(col.setting.label.layout).icon_class"><i :class="get_prefix(col.setting.label.layout).icon_class
                        "></i></span>
                      {{ get_prefix(col.setting.label.layout).label }}
                    </b-button>
                  </template>
                  <span>{{ col.setting.label.text }}</span>
                  <template v-if="get_suffix_type(col.setting.label.layout) === 'text'">
                    <span>{{ get_suffix(col.setting.label.layout) }}</span>
                  </template>
                  <template v-if="
                    get_suffix_type(col.setting.label.layout) === 'button'
                  ">
                    <b-button variant="link" :class="get_suffix(col.setting.label.layout).class
                      ? get_suffix(col.setting.label.layout).class
                      : ''
                      " size="sm" @click="
                        on_button_click(
                          get_suffix(col.setting.label.layout).name,
                          item
                        )
                        ">
                      <span v-if="get_suffix(col.setting.label.layout).icon_class"><i :class="get_suffix(col.setting.label.layout).icon_class
                        "></i></span>
                      {{ get_suffix(col.setting.label.layout).label }}
                    </b-button>
                  </template>{{ lable_end_char }}
                </div>
              </b-td>
            </template>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </slot>
    <div>
      <slot name="operation" v-bind="item">
        <div class="hb_entity_editor_submit_container">
          <el-button type="primary" @click="on_submit(item)">{{
            submit_text
            }}</el-button>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
// -- import * as _ from "lodash-es"
// import DivEditable from "./DivEditable";
import * as tools from "../../../shared/tools"
import * as commonController from '../../../controllers/commonController';

export default {
  props: {
    id: { type: String, default: () => commonController.getUUID() },
    title: { type: String, default: () => "entity editor" },
    lable_end_char: { type: String, default: () => ":" },
    striped: { type: Boolean, default: () => false },
    bordered: { type: Boolean, default: () => false },
    borderless: { type: Boolean, default: () => false },
    outlined: { type: Boolean, default: () => false },
    small: { type: Boolean, default: () => false },
    hover: { type: Boolean, default: () => false },
    fixed: { type: Boolean, default: () => false },
    noCollapse: { type: Boolean, default: () => false },
    submit_text: { string: String, default: () => "Submit" },
  },
  components: {},
  data() {
    return {
      item: {},
      //   item_info: [[{is_editor:false,label:'kasfjk'},{is_editor:true,label:'kasfjk'}]],
      settings: [],
    }
  },
  methods: {
    get_style(layout) {
      return layout && layout.style ? layout.style : ""
    },
    get_class(layout) {
      return layout && layout.class ? layout.class : ""
    },
    get_colspan(layout) {
      return layout && layout.colspan ? layout.colspan : "1"
    },
    get_prefix_type(layout) {
      if (layout && layout.prefix) return layout.prefix.type
      return null
    },
    get_prefix(layout) {
      if (layout && layout.prefix) {
        let prefix = layout.prefix
        if (prefix.type === "text") return prefix.text
        if (prefix.type === "button") return prefix.button
      }
      return ""
    },
    get_suffix_type(layout) {
      if (layout && layout.suffix) return layout.suffix.type
      return null
    },
    get_suffix(layout) {
      if (layout && layout.suffix) {
        let suffix = layout.suffix
        if (suffix.type === "text") return suffix.text
        if (suffix.type === "button") return suffix.button
      }
      return ""
    },
    get_delimiter(layout) {
      return layout && layout.delimiter ? layout.delimiter : ""
    },
    get_textarea(layout) {
      return layout && layout.textarea ? layout.textarea : null
    },
    get_resize(layout) {
      let textarea = this.get_textarea(layout)
      return textarea && textarea.resize ? textarea.resize : ""
    },
    get_rows(layout) {
      let textarea = this.get_textarea(layout)
      return textarea && textarea.rows ? textarea.rows : ""
    },
    get_autosize(layout) {
      let textarea = this.get_textarea(layout)
      return textarea && textarea.resize ? textarea.autosize : ""
    },
    get_maxlength(layout) {
      return layout && layout.maxlength ? layout.maxlength : ""
    },
    get_minlength(layout) {
      return layout && layout.minlength ? layout.minlength : ""
    },
    only_integer(e) {
      // console.log(e.key)
      e.returnValue =
        e.key.match(/\d+/) || e.key === "Backspace" || e.key === "Delete"
    },
    only_number(e) {
      e.returnValue =
        e.key.match(/[\d.]+/) || e.key === "Backspace" || e.key === "Delete"
    },
    on_focus(f, item) {
      this.$emit("on_focus", f, item)
    },
    on_change(f, item) {
      this.$emit("on_change", f, item)
    },
    on_button_click(button_name, item) {
      this.$emit("on_button_click", button_name, item)
      console.log(button_name)
    },
    on_input(f, type, item) {
      let this_ = this
      let data_type = type
      let key = f
      let v = item[key]
      console.log(f)
      if (data_type === "integer") {
        if (v === "") {
          Vue.set(item, key, null)
        } else {
          if (v.match(/\D+/)) {
            Vue.set(item, key, parseInt(v.replace(/\D/g, "")))
          } else {
            Vue.set(item, key, parseInt(v))
          }
        }
      } else if (data_type === "number") {
        if (v === "") {
          Vue.set(item, key, null)
        } else {
          if (v.match(/^\d+(.\d*)?$/)) {
            // Vue.set(item, key, parseFloat(v));
          } else {
            Vue.set(item, key, v.replace(/[^\.\d]/g, ""))
          }
        }
      }
      this_.$emit("on_input", item)


    },
    on_blur(f, type, item) {
      let this_ = this
      let data_type = type
      let key = f
      let v = item[key]
      if (data_type === "number") {
        let n = parseFloat(v)
        Vue.set(item, key, _.isNaN(n) ? null : n)
      }
      if (data_type === "integer") {
        let i = parseInt(v)
        Vue.set(item, key, _.isNaN(i) ? null : i)
      }
    },
    on_submit(item) {
      this.$emit("on_submit", item)
      console.log(item)
    },
    goto(route_link_to, num) {
      // let num = data.item[data.field.key];
      // this.$router.push({ name: data.field._route_link_to, query: { num } });
      tools.goto(this, route_link_to, { num })
    },
    SetData(settings, item) {
      /*
            [
  [
    {
      "value_fields": [
        "name"
      ],
      "type": "integer",
      "options": {
        "provider": "product_type_provider",
        "base_on_field": ""
      },
      "label": {
        "text": "产品类型",
        "layout": {}
      },
      "layout": {
        "variant": "",
        "style": "",
        "class": "",
        "colspan": 2,
        "prefix": "",
        "suffix": "",
        "delimiter": ""
      }
    },
    {
      "value_fields": [
        "name"
      ],
      "type": "integer",
      "options": {
        "provider": "product_type_provider",
        "base_on_field": ""
      },
      "label": {
        "text": "产品类型",
        "layout": {}
      },
      "layout": {
        "variant": "",
        "style": "",
        "class": "",
        "colspan": 2,
        "prefix": "",
        "suffix": "",
        "delimiter": ""
      }
    }
  ]
]
        */

      console.log(settings)
      let this_ = this
      let _seq = 0
      _.each(settings, function (setting) {
        let cols = []
        this_.settings.push({ seq: _seq++, cols })
        _.each(setting, function (s) {
          let value_fields = s.value_fields
          let type = s.type
          let options = s.options
          let label = s.label
          let editor = s.editor
          let readonly = !!s.readonly
          let route_link_to = s.route_link_to

          cols.push({
            seq: _seq++,
            is_editor: false,
            setting: { label, type },
          })

          if (!(type === "divider" || type === "")) {
            cols.push({
              seq: _seq++,
              is_editor: true,
              setting: { value_fields, type, options, editor, readonly, route_link_to },
            })
          }
        })
      })

      this_.item = Object.assign({}, this_.item, item)
      console.log(this_.settings)
    },
    display_options_value(value, options) {
      return tools.display_options_value(value, options)
    },
    display_value(type, value, _precise = 0) {
      // if (!_.isNumber(value)) return "";
      // if (_precise === undefined || _precise === 0) {
      //   return numbro(value).format({ thousandSeparated: true });
      // } else {
      //   return numbro(value).format({
      //     thousandSeparated: true,
      //     mantissa: _precise,
      //   });
      // }
      return tools.display_value(type, value, _precise)
    },
  },
}
</script>

<style scoped>
.hb_entity_editor_label_td {
  text-align: right;
  vertical-align: middle;
}

.hb_entity_editor_editor_td {
  text-align: left;
  vertical-align: middle;
}

.hb_table_column_number {
  width: 96px;
}

.hb_table_column_date.el-date-editor.el-input {
  width: 128px;
}

.hb_table_column_datetime.el-date-editor.el-input {
  width: 176px;
}

.hb_entity_editor_container>>>.el-divider {
  margin: 8px 0;
}

.hb_entity_editor_container>>>.table th,
.table td {
  padding: 0.1rem 0.2rem;
}

.hb_entity_editor_container>>>.el-checkbox {
  margin: auto;
}

.hb_entity_editor_submit_container {
  text-align: right;
  padding: 8px;
}

.hb_entity_editor_title {
  font-size: large;
  padding: 24px;
}

.hb_route_link_to_text {
  color: #20a8d8;
  font-weight: normal;
  text-decoration: none;
}
</style>
